import { render, staticRenderFns } from "./Personas.vue?vue&type=template&id=53b83d32&scoped=true"
import script from "./Personas.vue?vue&type=script&lang=js"
export * from "./Personas.vue?vue&type=script&lang=js"
import style0 from "./Personas.vue?vue&type=style&index=0&id=53b83d32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b83d32",
  null
  
)

export default component.exports